var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_359_26027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00006 15.837C12.3282 15.837 15.8368 12.3284 15.8368 8.00025C15.8368 3.67214 12.3282 0.163513 8.00006 0.163513C3.67196 0.163513 0.16333 3.67214 0.16333 8.00025C0.16333 12.3284 3.67196 15.837 8.00006 15.837Z",
    fill: "#BCB9B6",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.38794 7.99986L7.12944 9.74136L10.6124 6.25836",
    stroke: "#BA8D5B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_359_26027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.3b36d15ea315eb6c5aecbd3424503fdb.svg";
export { ForwardRef as ReactComponent };